import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { ExtendedMap } from '@jeppesen-foreflight/jmkw-types';
import { CommonModule, KeyValue } from '@angular/common';
import { RadioComponent } from '../../base/radio/radio.component';
import { RadioNode } from './radios.models';

@Component({
  selector: 'jmkw-radios',
  templateUrl: './radios.component.html',
  standalone: true,
  imports: [CommonModule, RadioComponent],
  styleUrls: ['./radios.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadiosComponent {
  @Input() name = 'default';
  @Input() selectedId?: string;
  @Input() radioNodeMap!: ExtendedMap<RadioNode>;

  @Output() nodeChanged = new EventEmitter<KeyValue<string, RadioNode>>();

  radioChangeHandler(
    selected: string,
    radioKeyValue: KeyValue<string, RadioNode>
  ): void {
    const updatedNode = this.toggle(radioKeyValue.value, selected);
    // this.radioNodeMap.set(radioKeyValue.key, updatedNode);
    this.nodeChanged.emit({ key: radioKeyValue.key, value: updatedNode });
  }

  toggle(node: RadioNode, selected: string): RadioNode {
    this.selectedId = selected;
    node.onChange?.(selected, node);

    return new RadioNode(node);
  }
}
